import { Component, inject, input, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ReportControl } from '@xmedical/core';
import { XmedicalUiModule } from '@xmedical/ui';
import { ReportControlEditorService } from '../../services/report-control-editor.service';

@Component({
  selector: 'xmed-comment-field-renderer',
  standalone: true,
  imports: [
    FormsModule,
    MatFormFieldModule,
    MatInputModule,
    XmedicalUiModule
  ],
  templateUrl: './comment-field-renderer.component.html',
  styleUrl: './comment-field-renderer.component.scss'
})
export class CommentFieldRendererComponent implements OnInit {
  private editorService = inject(ReportControlEditorService);

  control = input.required<ReportControl>();
  value = '';

  ngOnInit(): void {
    this.value = this.control().value;
  }

  onModelChanged(): void {
    this.editorService.triggerEvent();
  }
}
